import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table table-bordered" }
const _hoisted_3 = {
  class: "table-secondary",
  style: {"border-collapse":"collapse","border-left":"5px solid gray"}
}
const _hoisted_4 = {
  key: 0,
  class: "table-info"
}
const _hoisted_5 = {
  key: 1,
  class: "table-info"
}
const _hoisted_6 = { class: "revenues" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","flex-grow":"1"} }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "cogs" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "gross-margin" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "opex" }
const _hoisted_30 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "text-muted" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "ebita" }
const _hoisted_46 = { class: "text-muted" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "other-expenses" }
const _hoisted_50 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_51 = { class: "text-muted" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "text-muted" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_59 = { class: "text-muted" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "text-muted" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "adjusted-ebita" }
const _hoisted_66 = { class: "text-muted" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "spacer-row" }
const _hoisted_70 = {
  key: 0,
  class: "table-info"
}
const _hoisted_71 = {
  key: 1,
  class: "table-info"
}
const _hoisted_72 = {
  class: "table-secondary",
  style: {"border-collapse":"collapse","border-left":"5px solid gray"}
}
const _hoisted_73 = {
  key: 0,
  class: "table-info"
}
const _hoisted_74 = {
  key: 1,
  class: "table-info"
}
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_77 = { class: "text-muted" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "text-muted" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }

import { ref, computed, toRef } from 'vue'
    import type { PnlReportReadModel } from '@Quest/Pnls/Domain/readmodels'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlViewer',
  props: {
    readModel: {},
    cagrVisible: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- computed ----------------

    const numberOfColumns = computed(() =>
        rm.value.Columns.length
    )

    // ---------------- local UI state ----------------

    const revenuesCollapsed = ref(true)
    const opexCollapsed = ref(true)
    const cogsCollapsed = ref(true)
    const otherExpensesCollapsed = ref(true)

    // ---------------- actions ----------------

    function toggleRevenues()
    {
        revenuesCollapsed.value = !revenuesCollapsed.value
    }

    function toggleOpex()
    {
        opexCollapsed.value = !opexCollapsed.value
    }

    function toggleCogs()
    {
        cogsCollapsed.value = !cogsCollapsed.value
    }

    function toggleOtherExpenses()
    {
        otherExpensesCollapsed.value = !otherExpensesCollapsed.value
    }

return (_ctx: any,_cache: any) => {
  return (rm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "All values in: " + _toDisplayString(rm.value.CurrencyLabel), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Columns, (c) => {
                return (_openBlock(), _createElementBlock("th", null, _toDisplayString(c.Label), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_4, "3yr CAGR"))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_5, "5yr CAGR"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_6, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("div", {
                  onClick: toggleRevenues,
                  class: "pointer"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fa', revenuesCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up']),
                      style: {"margin-right":"10px"}
                    }, null, 2 /* CLASS */),
                    _createTextVNode(" " + _toDisplayString(rm.value.Revenues.Label), 1 /* TEXT */)
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-muted" }, "% growth", -1 /* CACHED */))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.Revenues.Values[i-1]) + " ", 1 /* TEXT */),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_8, _toDisplayString(rm.value.Revenues.GrowthPercentages[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(rm.value.Revenues.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(rm.value.Revenues.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!revenuesCollapsed.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rm.value.Revenues.Accounts, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(r.Label), 1 /* TEXT */),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-muted" }, "% growth", -1 /* CACHED */))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(r.Values[i-1]), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_11, _toDisplayString(r.GrowthPercentages[i-1]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(r.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(r.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("tbody", _hoisted_14, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("div", {
                  onClick: toggleCogs,
                  class: "pointer",
                  style: {"display":"flex","align-items":"center","flex-grow":"1"}
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(['fa', cogsCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up']),
                    style: {"margin-right":"10px"}
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(rm.value.Cogs.Label), 1 /* TEXT */)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(rm.value.Cogs.Values[i-1]), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_15, _toDisplayString(rm.value.Cogs.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(rm.value.Cogs.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!cogsCollapsed.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rm.value.Cogs.Accounts, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.Id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(c.Label), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(c.Values[i-1]), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(c.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(c.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          (!cogsCollapsed.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rm.value.Cogs.Subtotals, (sub) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  class: "cogs",
                  key: sub.Id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (sub.IsCollapsed = !sub.IsCollapsed),
                        class: "pointer"
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fa', sub.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up']),
                            style: {"margin-right":"10px"}
                          }, null, 2 /* CLASS */),
                          _createTextVNode(" " + _toDisplayString(sub.Label), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_19)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(sub.Values[i-1]), 1 /* TEXT */),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(sub.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(sub.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (!sub.IsCollapsed)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sub.Accounts, (e) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: e.Id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(e.Label), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                            return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(e.Values[i-1]), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("tbody", _hoisted_25, [
            _createElementVNode("tr", null, [
              _cache[7] || (_cache[7] = _createElementVNode("th", null, [
                _createTextVNode(" Gross margin "),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "text-muted" }, "% of sales")
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.GrossMargin.Values[i-1]), 1 /* TEXT */),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_26, _toDisplayString(rm.value.GrossMargin.PercentageOfSales[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_27, _toDisplayString(rm.value.GrossMargin.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(rm.value.GrossMargin.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_29, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("div", {
                  onClick: toggleOpex,
                  class: "pointer"
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fa', opexCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up']),
                      style: {"margin-right":"10px"}
                    }, null, 2 /* CLASS */),
                    _cache[8] || (_cache[8] = _createTextVNode(" Opex ", -1 /* CACHED */))
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.Opex.Values[i-1]), 1 /* TEXT */),
                  _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_31, _toDisplayString(rm.value.Opex.PercentageOfSales[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_32, _toDisplayString(rm.value.Opex.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_33, _toDisplayString(rm.value.Opex.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!opexCollapsed.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rm.value.Opex.Accounts, (e) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: e.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(e.Label), 1 /* TEXT */),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(e.Values[i-1]), 1 /* TEXT */),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_34, _toDisplayString(e.PercentageOfSales[i-1]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          (!opexCollapsed.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(rm.value.Opex.Subtotals, (sub) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  class: "opex",
                  key: sub.Id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (sub.IsCollapsed = !sub.IsCollapsed),
                        class: "pointer"
                      }, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fa', sub.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up']),
                            style: {"margin-right":"10px"}
                          }, null, 2 /* CLASS */),
                          _createTextVNode(" " + _toDisplayString(sub.Label), 1 /* TEXT */)
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                      ], 8 /* PROPS */, _hoisted_37)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(sub.Values[i-1]), 1 /* TEXT */),
                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_39, _toDisplayString(sub.PercentageOfSales[i-1]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(sub.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(sub.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (!sub.IsCollapsed)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sub.Accounts, (e) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: e.Id
                        }, [
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(e.Label), 1 /* TEXT */),
                            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                            return (_openBlock(), _createElementBlock("td", { key: i }, [
                              _createTextVNode(_toDisplayString(e.Values[i-1]), 1 /* TEXT */),
                              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("small", _hoisted_42, _toDisplayString(e.PercentageOfSales[i-1]), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("tbody", _hoisted_45, [
            _createElementVNode("tr", null, [
              _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                _createTextVNode(" EBITA "),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "text-muted" }, "% of sales")
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.EBITA.Values[i-1]), 1 /* TEXT */),
                  _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_46, _toDisplayString(rm.value.EBITA.PercentageOfSales[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_47, _toDisplayString(rm.value.EBITA.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_48, _toDisplayString(rm.value.EBITA.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_49, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("div", {
                  onClick: toggleOtherExpenses,
                  class: "pointer"
                }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fa', otherExpensesCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up']),
                      style: {"margin-right":"10px"}
                    }, null, 2 /* CLASS */),
                    _cache[21] || (_cache[21] = _createTextVNode(" Other expenses ", -1 /* CACHED */))
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.OtherExpenses.Values[i-1]), 1 /* TEXT */),
                  _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_51, _toDisplayString(rm.value.OtherExpenses.PercentageOfSales[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_52, _toDisplayString(rm.value.OtherExpenses.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_53, _toDisplayString(rm.value.OtherExpenses.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!otherExpensesCollapsed.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rm.value.OtherExpenses.Accounts, (e) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: e.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(e.Label), 1 /* TEXT */),
                      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(e.Values[i-1]), 1 /* TEXT */),
                        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_54, _toDisplayString(e.PercentageOfSales[i-1]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          (!otherExpensesCollapsed.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(rm.value.OtherExpenses.Subtotals, (sub) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  class: "other-expenses",
                  key: sub.Id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (sub.IsCollapsed = !sub.IsCollapsed),
                        class: "pointer"
                      }, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fa', sub.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up']),
                            style: {"margin-right":"10px"}
                          }, null, 2 /* CLASS */),
                          _createTextVNode(" " + _toDisplayString(sub.Label), 1 /* TEXT */)
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                      ], 8 /* PROPS */, _hoisted_57)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, [
                        _createTextVNode(_toDisplayString(sub.Values[i-1]), 1 /* TEXT */),
                        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_59, _toDisplayString(sub.PercentageOfSales[i-1]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(sub.Cagr3yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (__props.cagrVisible)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(sub.Cagr5yr), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (!sub.IsCollapsed)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sub.Accounts, (e) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: e.Id
                        }, [
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(e.Label), 1 /* TEXT */),
                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-muted" }, "% of sales", -1 /* CACHED */))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                            return (_openBlock(), _createElementBlock("td", { key: i }, [
                              _createTextVNode(_toDisplayString(e.Values[i-1]), 1 /* TEXT */),
                              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("small", _hoisted_62, _toDisplayString(e.PercentageOfSales[i-1]), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (__props.cagrVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("tbody", _hoisted_65, [
            _createElementVNode("tr", null, [
              _cache[33] || (_cache[33] = _createElementVNode("th", null, [
                _createTextVNode(" Adjusted EBITA "),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "text-muted" }, "% of sales")
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, [
                  _createTextVNode(_toDisplayString(rm.value.AdjustedEBITA.Values[i-1]), 1 /* TEXT */),
                  _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_66, _toDisplayString(rm.value.AdjustedEBITA.PercentageOfSales[i-1]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_67, _toDisplayString(rm.value.AdjustedEBITA.Cagr3yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_68, _toDisplayString(rm.value.AdjustedEBITA.Cagr5yr), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_69, [
            _createElementVNode("tr", null, [
              _cache[34] || (_cache[34] = _createElementVNode("th", null, null, -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Columns, (c) => {
                return (_openBlock(), _createElementBlock("th"))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_70))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_71))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("thead", _hoisted_72, [
            _createElementVNode("tr", null, [
              _cache[35] || (_cache[35] = _createElementVNode("th", null, "Resources", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Columns, (c) => {
                return (_openBlock(), _createElementBlock("th", null, _toDisplayString(c.Label), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_73, "3yr CAGR"))
                : _createCommentVNode("v-if", true),
              (__props.cagrVisible)
                ? (_openBlock(), _createElementBlock("th", _hoisted_74, "5yr CAGR"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Resources.Subtotals, (sub) => {
            return (_openBlock(), _createElementBlock("tbody", {
              class: "resources",
              key: sub.Unit
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (sub.IsCollapsed = !sub.IsCollapsed),
                    class: "pointer"
                  }, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', sub.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up']),
                        style: {"margin-right":"10px"}
                      }, null, 2 /* CLASS */),
                      _createTextVNode(" " + _toDisplayString(sub.Label), 1 /* TEXT */)
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-muted" }, "% growth", -1 /* CACHED */))
                  ], 8 /* PROPS */, _hoisted_75)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                  return (_openBlock(), _createElementBlock("td", { key: i }, [
                    _createTextVNode(_toDisplayString(sub.Values[i-1]), 1 /* TEXT */),
                    _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("small", _hoisted_77, _toDisplayString(sub.GrowthPercentages[i-1]), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                (__props.cagrVisible)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_78, _toDisplayString(sub.Cagr3yr), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (__props.cagrVisible)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_79, _toDisplayString(sub.Cagr3yr), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              (!sub.IsCollapsed)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sub.Accounts, (e) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: e.Id
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(e.Label), 1 /* TEXT */),
                        _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "text-muted" }, "% growth", -1 /* CACHED */))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColumns.value, (i) => {
                        return (_openBlock(), _createElementBlock("td", { key: i }, [
                          _createTextVNode(_toDisplayString(e.Values[i-1]), 1 /* TEXT */),
                          _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", _hoisted_80, _toDisplayString(e.GrowthPercentages[i-1]), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (__props.cagrVisible)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_81, _toDisplayString(e.Cagr3yr), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (__props.cagrVisible)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(e.Cagr5yr), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})